"use client"

import { KnowledgeHub } from '@/components/knowledge/KnowledgeHub'

export function KnowledgeView() {
    return <KnowledgeHub />
}
